import type { IconSvgObject } from './types';

const EditRoadIcon: IconSvgObject = [
  ["path", { d: "M13 17.5V20H15.5L21 14.5L18.5 12L13 17.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 3.5V20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 3.5V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9.5 3.5V6.5M9.5 10.5V13.5M9.5 17.5V20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default EditRoadIcon;
